module.exports = __webpack_public_path__ + "img/17.1651a945.jpg";